import { DmLuongNangSuatModel } from './dmluongnangsuat.model';
import { DmLuongCapBacModel } from './dmluongcapbac.model';
import { DmQuaTrinhCongTacModel } from './dmquatrinhcongtac.model';
import { DmCheDoModel } from './dmchedo.model';
import { DmChuyenNganhModel } from './dmchuyennganh.model';
import { DmNguoiPhuThuocModel } from './dmnguoiphuthuoc.model';
import { DmTaiLieuModel } from './dmtailieu.model';
import { DmNhanXetHangNamModel } from './dmnhanxethangnam.model';
import { DmHopDongLaoDongModel } from './dmhopdonglaodong.model';
import { DmKyLuatModel } from './dmkyluat.model';
import { DmKhenThuongModel } from './dmkhenthuong.model';
import { DmNangDinhModel } from './dmnangdinh.model';
import { DmQuaTrinhDongBhxhModel } from './dmquatrinhdongbhxh.model';
import { NhanThanModel } from './nhanthan.model';
import { DmDonViModel } from './dmdonvi.model';
import { DmHoiDongModel } from './dmhoidong.model';
import { DmQtctDoanThanhNienModel } from './dmqtctdoanthanhnien.model';
import { DmQtctCongDoanModel } from './dmqtctccongdoan.model';
import { DmQtctDangModel } from './dmqtctdang.model';
import { SafeUrl } from '@angular/platform-browser';
import { DmLuongModel } from './dmluong.model';
import { FileUploadResultModel } from "./dmuploadfile.model";
export class NhanVienModel {
  constructor(dmDonVi?: DmDonViModel,
              dmQtctDangs?: DmQtctDangModel[],
              dmQtctCongDoans?: DmQtctCongDoanModel[],
              dmQtctDoanThanhNiens?: DmQtctDoanThanhNienModel[],
              dmHoiDongs?: DmHoiDongModel[],
              nhanThans?: NhanThanModel[],
              dmQuaTrinhDongBhxhs?: DmQuaTrinhDongBhxhModel[],
              dmNangDinhs?: DmNangDinhModel[],
              dmKhenThuongs?: DmKhenThuongModel[],
              dmKyLuats?: DmKyLuatModel[],
              dmHopDongLaoDongs?: DmHopDongLaoDongModel[],
              dmNhanXetHangNams?: DmNhanXetHangNamModel[],
              dmTaiLieus?: DmTaiLieuModel[],
              dmNguoiPhuThuocs?: DmNguoiPhuThuocModel[],
              dmChuyenNganhs?: DmChuyenNganhModel[],
              dmCheDos?: DmCheDoModel[],
              dmQuaTrinhCongTacs?: DmQuaTrinhCongTacModel[],
              dmLuongs?: DmLuongModel[]) {
        this.dmDonVi = dmDonVi || new DmDonViModel();
        this.dmQtctDangs = dmQtctDangs || new Array<DmQtctDangModel>();
        this.dmQtctCongDoans = dmQtctCongDoans || new Array<DmQtctCongDoanModel>();
        this.dmQtctDoanThanhNiens = dmQtctDoanThanhNiens || new Array<DmQtctDoanThanhNienModel>();
        this.dmHoiDongs = dmHoiDongs || new Array<DmHoiDongModel>();
        this.nhanThans = nhanThans || new Array<NhanThanModel>();
        this.dmQuaTrinhDongBhxhs = dmQuaTrinhDongBhxhs || new Array<DmQuaTrinhDongBhxhModel>();
        this.dmNangDinhs = dmNangDinhs || new Array<DmNangDinhModel>();
        this.dmKhenThuongs = dmKhenThuongs || new Array<DmKhenThuongModel>();
        this.dmKyLuats = dmKyLuats || new Array<DmKyLuatModel>();
        this.dmHopDongLaoDongs = dmHopDongLaoDongs || new Array<DmHopDongLaoDongModel>();
        this.dmNhanXetHangNams = dmNhanXetHangNams || new Array<DmNhanXetHangNamModel>();
        this.dmTaiLieus = dmTaiLieus || new Array<DmTaiLieuModel>();
        this.dmNguoiPhuThuocs = dmNguoiPhuThuocs || new Array<DmNguoiPhuThuocModel>();
        this.dmChuyenNganhs = dmChuyenNganhs || new Array<DmChuyenNganhModel>();
        this.dmCheDos = dmCheDos || new Array<DmCheDoModel>();
        this.dmQuaTrinhCongTacs = dmQuaTrinhCongTacs || new Array<DmQuaTrinhCongTacModel>();
        this.dmLuongs = dmLuongs || new Array<DmLuongModel>();
   }
  public id: number;
  public hoVaTen: string;
  public maNhanVien: string;
  public image: string;
  public imageResource: any;
  public imageFinal: SafeUrl | null;
  public maHoSo: string;
  public gioiTinh: number;
  public ngaySinh: Date;
  public noiSinh: string;
  public queQuan: string;
  public danToc: string;
  public tonGiao: string;
  public hoKhauThuongTru: string;
  public noiOHienNay: string;
  public tdGiaoDucPhoThong: string;
  public tdChuyenMon: string;
  public tdLyLuanChinhTri: string;
  public quanLyNhaNuoc: string;
  public ngoaiNgu: string;
  public tinHoc: string;
  public ngayNhapNgu: Date;
  public ngayXuatNgu: Date;
  public quanHamCaoNhat: string;
  public giaDinhChinhSach: string;
  public soCmnd: string;
  public noiCap: string;
  public ngayCap: Date;
  public email: string;
  public soDienThoai: string;
  public ngheNghiepKhiTuyen: string;
  public ngayTuyenDung: Date;
  public ngayVaoHangKhong: Date;
  public ngayVaoQuanLyBay: Date;
  public ngayVaoTtQuanLyKhongLuu: Date;
  public chucVuDang: string;
  public ngayVaoDang: Date;
  public ngayChinhThucDang: Date;
  public soHoSoDang: String;
  public soLyLichDang: string;
  public soTheDang: string;
  public phuCapDang: string;
  public chucVuCongDoan: string;
  public ngayVaoCongDoan: Date;
  public phuCapCongDoan: string;
  public chucVuDoanThanhNien: string;
  public ngayVaoDoanThanhNien: Date;
  public soSoBhxh: string;
  public ngayCapBhxh: Date;
  public noiCapBhxh: string;
  public ngayThamGiaBhxh: Date;
  public soThangGianDoanBhxh: number;
  public soTheBhyt: string;
  public noiDkKcbBanDau: string;
  public thoiGianDkNoiKcbbd: Date;
  public soSo: string;
  public dmDonVi: DmDonViModel;
  public maSoThue: string;
  public ngayCapMst: Date;
  public coQuanQuanLy: string;
  public chucDanhCongViecHienTai: string;
  public chucDanhCongViecTheoHdld: string;
  public boPhanCongTac: string;
  public soCmndThue: string;
  public soTaiKhoan: string;
  public tenTaiKhoan: string;
  public tenNganHang: string;
  public tenChiNhanh: string;
  public namTotNghiepLyLuanChinhTri: string;
  public namTotNghiepQuanLyNhaNuoc: string;
  public ngayThangLamCongViecHienTai: Date;
  public ngayThangDuocBoNhiem: Date;
  public coQuanTuyenDung: string;
  public soNguoiPhuThuoc: number;
  public dmQtctDangs: DmQtctDangModel[];
  public dmQtctCongDoans: DmQtctCongDoanModel[];
  public dmQtctDoanThanhNiens: DmQtctDoanThanhNienModel[];
  public dmHoiDongs: DmHoiDongModel[];
  public nhanThans: NhanThanModel[];
  public dmQuaTrinhDongBhxhs: DmQuaTrinhDongBhxhModel[];
  public dmNangDinhs: DmNangDinhModel[];
  public dmKhenThuongs: DmKhenThuongModel[];
  public dmKyLuats: DmKyLuatModel[];
  public dmHopDongLaoDongs: DmHopDongLaoDongModel[];
  public dmNhanXetHangNams: DmNhanXetHangNamModel[];
  public dmTaiLieus: DmTaiLieuModel[];
  public dmNguoiPhuThuocs: DmNguoiPhuThuocModel[];
  public dmChuyenNganhs: DmChuyenNganhModel[];
  public dmCheDos: DmCheDoModel[];
  public dmQuaTrinhCongTacs: DmQuaTrinhCongTacModel[];
  public dmLuongCapBacs: DmLuongCapBacModel[];
  public dmLuongNangSuats: DmLuongNangSuatModel[];
  public dmLuongs: DmLuongModel[];
}
export class NhanVienSearch {
  constructor(pageNumber?: number,
              pageSize?: number,
              username?: string,
              fullname?: string,
              email?: string,
              fromDate?: Date,
              toDate?: Date,
              roleId?: number,
              gender?: number,
              keyword?: string,
              donViId?: number,
              months?: number,
              phongBanId?: number,
              trangThai?: number,
              ids?:number[]) {
        this.pageNumber = pageNumber || 1;
        this.pageSize = pageSize || 10;
        this.username = username;
        this.fullname = fullname;
        this.email = email;
        this.fromDate = fromDate;
        this.toDate = toDate;
        this.roleId = roleId;
        this.keyword = keyword;
        this.donViId = donViId;
        this.phongBanId = phongBanId;
        this.gender = gender;
        this.months = months;
        this.trangThai = trangThai || 1;
        this.ids = ids;
  }
  public pageNumber: number;
  public pageSize: number;
  public donViId: number;
  public phongBanId: number;
  public username: string;
  public fullname: string;
  public email: string;
  public fromDate: Date;
  public toDate: Date;
  public roleId: number;
  public keyword: string;
  public gender: number;
  public months: number;
  public trangThai: number;
  public ids: number[];
}


export class NhanVienUpdateModel{
  constructor() {}
  public trangThai: number;
  public ids: number[];
}


export class ImportNhanVienModel {
  constructor() {}
  public successList: NhanVienModel[];
  public failList: FileUploadResultModel[];
  public sendMail: boolean;
  public status: boolean;
  public message: string;
}
